export const STAGE = window.location.hostname === 'rightrecruit.io' ? "client-api" : "dev-api";
